import React from 'react';
import Checkbox from "../ui/checkbox/Checkbox";
import Label from "../ui/labels/Label";
import { useMapControl } from '../../contexts/MapControlContext';

/**
 * Controls  to toggle map markers on or off
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - Map
 */
export const MapControl = () => {
    const { mapControl, handleMapControlChange } = useMapControl();

    const containerClasses = "flex gap-2 max-w-min sm:max-w-96 items-center"
    
    return (
        <>
            {/* MAP CONTROLS */}
            <div className='flex gap-5'>
                <div className={containerClasses}>
                    <Label forId="sc-toggle" className="flex-1">{mapControl['sc-toggle'] ? 'Hide Subchains' : 'Show Subchains'}</Label>
                    <Checkbox
                        name='sc-toggle'
                        onChange={handleMapControlChange}
                        initiallyChecked={mapControl['sc-toggle']}
                        className="shrink-0"

                    />
                </div>
                <div className={containerClasses}>
                    <Label forId="agm-toggle" className="flex-1">{mapControl['agm-toggle'] ? 'Hide AGMs' : 'Show AGMs'}</Label>
                    <Checkbox
                        name='agm-toggle'
                        onChange={handleMapControlChange}
                        initiallyChecked={mapControl['agm-toggle']}
                        className="shrink-0"

                    />
                </div>
                <div className={containerClasses}>
                    <Label forId="label-toggle" className="flex-1">{mapControl['label-toggle'] ? 'Hide Labels' : 'Show Labels'}</Label>
                    <Checkbox
                        name='label-toggle'
                        onChange={handleMapControlChange}
                        initiallyChecked={mapControl['label-toggle']}
                        className="shrink-0"
                    />
                </div>
                <div className={containerClasses}>
                    <Label forId="label-toggle" className="flex-1">{mapControl['label-toggle'] ? 'Show SC Labels' : 'Hide SC Labels'}</Label>
                    <Checkbox
                        name='sc-label-toggle'
                        onChange={handleMapControlChange}
                        initiallyChecked={mapControl['sc-label-toggle']}
                        className="shrink-0"
                    />
                </div>
            </div>
        </>
    );
};
